import { Component, OnInit } from '@angular/core';
import { EventService } from '../../controller/event.service';

@Component({
  selector: 'app-register-timezone',
  templateUrl: './register-timezone.component.html',
  styles: []
})
export class RegisterTimezoneComponent implements OnInit {
  constructor(
    public EventController: EventService
  ) { }

  ngOnInit() {

    console.log("🚀 ~ file: register-timezone.component.ts ~ line 13 ~ RegisterTimezoneComponent ~ EventController", this.EventController)
  }

}



// WEBPACK FOOTER //
// ./src/app/screens/register-event/view/register-timezone/register-timezone.component.ts